import { Controller } from "@hotwired/stimulus";
import JustValidate from "just-validate";
import { applyPendingAuthContinuation } from "./support/auth_continuation"

// data-controller="login"
export default class extends Controller {
    connect() {
        const prefix = `#${this.element.id}`
        this.validator = new JustValidate(this.element, { validateBeforeSubmitting: true });

        this.validator
            .addField(`${prefix} [name="account[username]"]`, [
                { rule: 'required', errorMessage: 'Email address is required' },
                { rule: 'email',    errorMessage: 'Please enter a valid email' },
            ])
            .addField(`${prefix} [name="account[password]"]`, [
                { rule: 'required', errorMessage: 'Password is required' },
            ])
            .onSuccess((event) => {
                applyPendingAuthContinuation(event.target)
                event.target.submit();
            });
    }

    disconnect() {
        this.validator?.destroy?.()
    }
}
